module.exports = __webpack_public_path__ + "static/img/chatroom_send.487ff69f.svg";